import { createContext } from "react";

import type { Child } from "@/lib/api";

export interface SessionState {
  childrenList: Child[];
  activeChild: Child | null;
  guardianUnlocked: boolean;
  loading: boolean;
  selectChild: (childId: string) => Promise<void>;
  unlockGuardian: (pin: string) => Promise<boolean>;
  signOut: () => Promise<void>;
}

export const SessionContext = createContext<SessionState | null>(null);